

/** Define tracking events based on requirements */
export abstract class GtmService {

  abstract pushEvent(trackEvent: object, clearEcommerce?: boolean): void;
}
